(function ($) {
    $(function () {

        var mapBlock = $('.flexible-content-section .map-block');

        if (mapBlock.length < 1) {
            return;
        }

        $(function () {
            $('[data-google-map]').each(function (boxIndex, boxElement) {
                var box = $(boxElement);
                var data = box.data('google-map');

                if (typeof data === 'string') {
                    data = JSON.parse(data);
                }

                box.googleMaps(data);
            });
        });

    });
})(jQuery);